import axios from 'axios'
import store from '@/store/index'

const ApiRequest = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

ApiRequest.interceptors.response.use(response => {
  return response.data
}, error => {
  if (axios.isCancel(error)) {
    return Promise.reject(error)
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response.status === 401 || error.response.status === 503) {
    store.dispatch('auth/sessionLogout')
  }
  return Promise.reject(error)
})
// 503 = kein login

export default ApiRequest
